<template>
  <div>
    <QueryFrame
      :disablePage="true"
    >
        <div slot="queryParams">
            <div class="queryContainer">
                <div class="queryItem">
                    <lk-button class="mr" type="primary" @click="signIn">签到</lk-button>
                    <lk-button @click="signOut">签退</lk-button>
                </div>
            </div>
        </div>
        <div slot="table">
          <lk-table border :columns="columns" :data="tableData"></lk-table>
        </div>
    </QueryFrame>
  </div>
</template>
<script>
import QueryFrame from '../../../components/frame/QueryFrame.vue';
import utils from '../../../libs/utils';
import insurance from '../../../services/insuranceLanzhou';
import mapState from '../../../mixins/mapState'; // 鉴权
import queryMixins from '../../../mixins/queryMixins';

export default {
  name: 'Sign',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  computed: {},
  data() {
    return {
      columns: [
        {
          title: '序号',
          type: 'index',
          minWidth: 80,
        },
        {
          title: '操作人',
          key: 'username',
          minWidth: 116,
        },
        {
          title: '操作类型',
          key: 'signType',
          minWidth: 116,
        },
        {
          title: '状态',
          key: 'status',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '操作时间',
          key: 'signTime',
          minWidth: 116,
          tooltip: true,
        },
      ],
      tableData: [],
      signTypeArr: ['签到', '签退']
    };
  },
  methods: {
    signIn() {
      const params = { opterNo: '00001' };
      insurance.signIn(params).then(res => {
        if(res.data.status === 200) {
          this.$Message.success('签到成功');
          let temp = res.data.data;
          temp.signType = this.signTypeArr[temp.signType];
          temp.status = res.data.success ? '成功' : '失败';
          this.tableData = [temp];
          localStorage.setItem('signInfo', JSON.stringify(this.tableData));
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    signOut() {
      const params = { opterNo: '00001' };
      insurance.signOut(params).then(res => {
        if(res.data.status === 200) {
          this.$Message.success('签退成功');
        }
      }).catch(err => {
        this.$Message.error(res.data.error);
      })
    }
  },
  created() {
    const data = localStorage.getItem('signInfo');
    if (data) {
      this.tableData = JSON.parse(data);
    }
  },
};
</script>
<style lang="less" scoped>
  .btns {
    margin-bottom: 8px;
    >* {
      margin-right: 8px
    }
  }
</style>
